(() => {
  'use strict';

  // ---------- Mobile menu ----------
  const drawer = document.querySelector('[data-mobile-drawer]');
  const openBtn = document.querySelector('[data-menu-toggle]');
  const closeBtn = document.querySelector('[data-menu-close]');

  if (openBtn && drawer) {
    openBtn.addEventListener('click', () => {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', () => {
      drawer.hidden = true;
      document.body.style.overflow = '';
    });
  }

  // ---------- Variant selector + option current label ----------
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const inputs = form.querySelectorAll('[data-option-input]');
    const submit = form.querySelector('[data-add-to-cart]');
    if (!variantSelect) return;

    const updateVariant = (changed) => {
      if (changed) {
        const idx = changed.dataset.optionIndex;
        const label = form.querySelector(`[data-option-current="${idx}"]`);
        if (label) label.textContent = changed.value;
      }
      const selected = Array.from(form.querySelectorAll('[data-option-input]:checked')).map(i => i.value);
      const target = Array.from(variantSelect.options).find(opt => opt.dataset.options === selected.join(' / '));
      if (target) {
        variantSelect.value = target.value;
        // Actualizar el precio mostrado según la variante elegida
        const priceWrap = document.querySelector('.product__price');
        if (priceWrap) {
          const cur = priceWrap.querySelector('.price__current');
          if (cur && target.dataset.price) cur.textContent = target.dataset.price;
          const cmp = priceWrap.querySelector('.price__compare');
          if (cmp) {
            if (target.dataset.compare) {
              cmp.textContent = target.dataset.compare;
              cmp.hidden = false;
            } else {
              cmp.hidden = true;
            }
          }
        }
        if (target.disabled) {
          submit.disabled = true;
          submit.textContent = 'Agotado';
        } else {
          submit.disabled = false;
          submit.textContent = 'Añadir al carrito';
        }
      }
    };
    inputs.forEach(i => i.addEventListener('change', () => updateVariant(i)));
  });

  // ---------- Product page qty stepper ----------
  document.querySelectorAll('[data-product-form] .qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('[data-qty-input]');
    const dec = stepper.querySelector('[data-qty-decrease]');
    const inc = stepper.querySelector('[data-qty-increase]');
    if (!input) return;
    dec?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    inc?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ---------- Size guide modal (open/close) ----------
  const sizeModal = document.querySelector('[data-size-modal]');
  if (sizeModal) {
    const openSize = () => {
      sizeModal.hidden = false;
      sizeModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const closeSize = () => {
      sizeModal.hidden = true;
      sizeModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-open-size-guide]').forEach((el) => {
      el.addEventListener('click', (e) => { e.preventDefault(); openSize(); });
    });
    sizeModal.querySelectorAll('[data-size-close]').forEach((el) => {
      el.addEventListener('click', closeSize);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !sizeModal.hidden) closeSize();
    });
  }

  // ---------- Size guide tabs (global, funciona dentro y fuera del modal) ----------
  document.querySelectorAll('.size-tabs').forEach((tabsContainer) => {
    const tabs = tabsContainer.querySelectorAll('[data-size-tab]');
    // Buscar panels en el contenedor padre que envuelve tabs + panels
    const root = tabsContainer.closest('.size-modal__panel, .size-guide-page, .size-tables-wrap') || tabsContainer.parentElement;
    const panels = root.querySelectorAll('[data-size-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.sizeTab;
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const show = p.dataset.sizePanel === target;
          p.classList.toggle('is-active', show);
          p.hidden = !show;
        });
      });
    });
  });

  // ---------- Testimonials carousel ----------
  document.querySelectorAll('[data-testimonials]').forEach((wrap) => {
    const items = wrap.querySelectorAll('.testimonial');
    const dots = wrap.querySelectorAll('[data-testimonials-dot]');
    if (items.length <= 1) return;
    wrap.setAttribute('data-mode', 'carousel');
    items.forEach((it, i) => it.classList.toggle('is-active', i === 0));
    let current = 0;
    const goTo = (idx) => {
      current = (idx + items.length) % items.length;
      items.forEach((it, i) => it.classList.toggle('is-active', i === current));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    };
    dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); restart(); }));
    let timer;
    const restart = () => { clearInterval(timer); timer = setInterval(() => goTo(current + 1), 5000); };
    restart();
  });

  // ---------- Product gallery ----------
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = thumb.dataset.index;
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.index === idx));
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  });

  // ---------- Cart drawer ----------
  const cartDrawer = document.querySelector('[data-cart-drawer]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    startTimer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Cart toggles (cart icon in header)
  document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });
  // Close buttons inside drawer
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) {
      closeCart();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
  });

  // ---------- Add to cart (ajax) ----------
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo...';
      try {
        const data = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Error');
        await refreshDrawer();
        openCart();
        btn.textContent = '¡Añadido!';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
      } catch {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
      }
    });
  });

  // Quick add from product cards
  document.querySelectorAll('[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      try {
        await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
        await refreshDrawer();
        openCart();
      } catch {}
    });
  });

  // ---------- Quantity steppers & remove ----------
  document.addEventListener('click', async (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const line = parseInt(item.dataset.line, 10);
    const input = item.querySelector('[data-qty-input]');
    let qty = parseInt(input.value, 10);

    if (e.target.closest('[data-qty-decrease]')) qty = Math.max(0, qty - 1);
    else if (e.target.closest('[data-qty-increase]')) qty = qty + 1;
    else if (e.target.closest('[data-cart-remove]')) qty = 0;
    else return;

    await updateLine(line, qty);
  });

  document.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-qty-input]')) return;
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const line = parseInt(item.dataset.line, 10);
    const qty = Math.max(0, parseInt(e.target.value, 10) || 0);
    await updateLine(line, qty);
  });

  async function updateLine(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      await refreshDrawer();
    } catch {}
  }

  async function refreshDrawer() {
    if (!cartDrawer) return;
    try {
      const res = await fetch(window.location.pathname || '/', { headers: { 'Accept': 'text/html' } });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newPanel = doc.querySelector('[data-cart-drawer] .cart-drawer__panel');
      const currentPanel = cartDrawer.querySelector('.cart-drawer__panel');
      if (newPanel && currentPanel) currentPanel.innerHTML = newPanel.innerHTML;

      // Update header count
      const newCount = doc.querySelector('[data-cart-count]');
      const cur = document.querySelector('[data-cart-count]');
      if (newCount && cur) cur.textContent = newCount.textContent;
    } catch (err) {
      console.warn('Cart refresh failed', err);
    }
  }

  // ---------- Reserved timer ----------
  let timerInterval = null;
  function startTimer() {
    const timerEl = document.querySelector('[data-cart-timer-value]');
    if (!timerEl) return;
    if (timerInterval) return; // already running
    const minutes = parseInt(timerEl.closest('[data-cart-timer]').dataset.minutes, 10) || 10;
    let remaining = minutes * 60;
    const tick = () => {
      const m = Math.floor(remaining / 60);
      const s = remaining % 60;
      timerEl.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      if (remaining <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        return;
      }
      remaining--;
    };
    tick();
    timerInterval = setInterval(tick, 1000);
  }
})();
